import type { AddressResult } from '@chain-zen/ui'
import { AddressSearchInput, Button, PlusIcon, X } from '@chain-zen/ui'
import { useTheme } from 'next-themes'
import React, { useState } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'

import type { ISearchResultDTO } from '../../../../../types/stop'

/**
 * This component is used to add a stop to the shipment.
 */
export const AddStop = ({ onAddStopAction }: { onAddStopAction: (stop: ISearchResultDTO) => void }) => {
  const { theme } = useTheme()
  const [open, setOpen] = useState(false)
  const methods = useForm({
    defaultValues: {
      warehouse: ''
    }
  })

  const handlePlaceSelect = (event: React.SyntheticEvent<HTMLInputElement> | CustomEvent<AddressResult>) => {
    if (!('detail' in event)) return

    const detail = event.detail
    const {
      addressLabel,
      city,
      country,
      postalCode,
      countryCode,
      state,
      stateCode,
      street,
      streetNumber,
      placeID,
      latitude,
      longitude,
      type
    } = detail

    const title = addressLabel?.split(',')[0].trim() || ''

    const stopData: ISearchResultDTO = {
      address: {
        city: city || null,
        country: country || null,
        countryCode: countryCode || null,
        postalCode: postalCode || null,
        postalCodeSuffix: null,
        state: state || null,
        stateCode: stateCode || null,
        street: street || null,
        streetNumber: streetNumber || null
      },
      addressLabel,
      exactMatch: null,
      existingPlace: null,
      gpsCoordinates: {
        latitude,
        longitude
      },
      id: '',
      placeID,
      position: null,
      rating: null,
      reviews: null,
      thumbnail: null,
      title,
      type
    }

    onAddStopAction(stopData)
    setOpen(false)
    methods.reset()
  }

  if (!open) {
    return (
      <Button size="sm" onClick={() => setOpen(true)}>
        <PlusIcon className="h-4 w-4" />
        Add Stop
      </Button>
    )
  }

  return (
    <div className="flex justify-between w-full gap-2 items-center">
      <FormProvider {...methods}>
        <form className="space-y-4 w-full">
          <Controller
            name="warehouse"
            control={methods.control}
            render={({ field }) => (
              <AddressSearchInput
                {...field}
                placeholder="Enter warehouse name or address"
                name={'warehouse'}
                onSelect={handlePlaceSelect}
                currentTheme={theme as 'light' | 'dark'}
              />
            )}
          />
        </form>
      </FormProvider>
      <Button size="sm" variant="ghost" onClick={() => setOpen(false)}>
        <X className="h-4 w-4" />
      </Button>
    </div>
  )
}
